// import 'element-closest';
var $ = require('jquery');
require('./web/locale');
//-- shimované pluginy většinou nemají export, většinou extendují jQuery object
// Pokud se prodá cl v3 tak smazat jQ a nahradit webcomponentoou
require('./web/jquery.gm');
require('fg-frontend/plugins/jquery.password-toggle');
require('fg-frontend/plugins/jquery.social-share');
require('fg-frontend/third/jquery.ba-throttle-debounce');
require('fg-frontend/third/jquery-ui/datetimePicker/timepicker');
require('fg-frontend/third/jquery-ui/datetimePicker/i18n/jquery-ui-timepicker-cs');
require('fg-frontend/third/jquery.log');
require('bootstrap/collapse');
require('jquery-ui/ui/widgets/datepicker');
require('jquery-ui/ui/i18n/datepicker-cs');
require('./web/highslide-settings');
require('./web/svgRegionsMap');
require('./web/jquery.flexslider');
require('./web/flexslider-settings');
require('./web/formFloatingLabels');
require('./web/transformeTabs');
require('./web/googlemaps-config');
require('./web/googlemaps-settings');
require('./web/googlemaps-tooltip');
require('./web/fluidWidthVideo');
require('./web/jquery.faq');
require('./web/jquery.debouncedResize');

require('./web/jquery.toggleBox');
require('./web/jquery.busHire');
require('./web/jquery.searchPlaces');

// require('./web/typeahead.bundle');
// const Bloodhound = require('./web/bloodhound');
// import './web/Typeahead';


//-- export to window
window.$ = $;
window.jQuery = $;
window.isTouchDevice = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0));

var _debugEnabled = true;
var body = $('body');
var projectConfig = window.projectConfig || {};


/**
 * Write log console for debug scripts
 */
projectConfig.log = function (l, msg) {
  if (typeof (msg) !== 'string') {msg = '-';}
  if (_debugEnabled && window.console) {
    console.log(l);
    console.log('-- Debug: ' + msg + ' :End --');
  }
};

/**
 * Get actual page lang
 * @type {*|jQuery}
 */
projectConfig.lang = function () {
  var lng = $('html').attr('lang');
  if (typeof (lng) !== 'string') {lng = 'cs';}
  if (lng == '' || !lng) {
    lng = 'cs';
  }
  return lng;
};
//- projectConfig.log(projectConfig.lang(),"get lang");

/**
 Ramjet - vykonání po výměně contentu (odeslání formu)
 */
$(document).on('afterContentsReplaced', function (e) {
  linkShowAllNewsParamert();
  // hodnocení
  $('.radio-select--evaluate').each(function () {
    var $t = $(this);
    var thisIndex = $('input:checked', this).val();

    if (thisIndex > 0) {
      $('.radio label', $t).removeClass('active');
      for (var i = 0; i < thisIndex; i++) {
        $('.radio label', $t).eq(i).addClass('active');
      }
    }

    $('input', $(this)).on('change', function () {
      var thisIndex = $(this).val();

      $('.radio label', $t).removeClass('active');
      for (var i = 0; i < thisIndex; i++) {
        $('.radio label', $t).eq(i).addClass('active');
      }
    });
  });

});

/**
 * automatické ošetření sdílecích tlačítek.
 *
 * HTML markup
 * <div class="js_social-share">
 *     <a href="javascript:void(0)" data-social-network="twitter"> Sdílet na Twitteru</a>
 * </div>
 *
 * data-social-network: facebook | twitter | gplus | linkedin | pinterest
 *
 * na odkaz možno dodat data:
 * data-share-title - vlastní titulek (pokud má být různý od document.title)
 * data-url-share - vlastní URL sdíleného článku, pokud se má lišit od document.URL
 * data-pinterest-image - podstrčení obrázku, který má být připinnován na pinterest
 */
$('.js_social-share a[data-social-network]').socialShare();

/**
 * password toggle - prepinani type = password | text
 *
 */
var jsPassToggle = $('.js_form-control-password-toggle');
jsPassToggle.passwordToggle();
$(document).on('ajaxComplete', function () {
  jsPassToggle.passwordToggle();
});

/**
 * Button zpět
 */
var jsBack = $('.js_back');
jsBack.on('click', function (e) {
  e.preventDefault();
  window.history.back();
});
jsBack.each(function () {
  if (history.length <= 1) {
    $(this).hide();
  }
});

/**
 * Pozicování search widgetu vzhledem ke spouštěcímu buttonu
 */
projectConfig.searchWidget = function () {
  let wrappElement = $('.header-search-panel-container'),
    headerElement = $('.p-header'),
    headerTopElement = $('.header-top', headerElement),
    windowWidth = $('body').width();
  if (wrappElement.length > 0) {
    if(windowWidth > 750) {
      let headerHeight = parseInt(headerElement.outerHeight());
      let headerTopHeight = parseInt(headerTopElement.outerHeight());
      wrappElement.css('top', (headerTopHeight - headerHeight) + 'px');
    } else {
      wrappElement.removeAttr('style');
    }
  }
};

/**
 * Animovany burger
 */
body.on('click', '.js_toggleCloseClass', function (e) {
  //- projectConfig.log($(this),"click burger");
  $(this).toggleClass('close');
  e.preventDefault();
});

/**
 * RWD tables
 */
$('table.table').each(function () {
  $(this).wrap('<div class="table-responsive"></div>');
});

/**
 * Fluid Width Video
 * - wrapper ".videoBox"
 */
$.fn.fluidWidthVideo({state: 'init'});

/**
 * Search widget position init
 */
projectConfig.searchWidget();

/**
 Window resize - vykonání při změně velikosti okna prohlížeče
 */
$(window).smartresize(function() {
  $.fn.fluidWidthVideo();
  projectConfig.searchWidget();
});

var benefitsListContent = function () {
  var $block = $('.js_benefitsList');
  var countElements = $block.children().size();
  var currentBenefit = 0;

  var init = function () {
    $('body').append('<div class="modalBenefits"><div class="modalBenefits_wrapper"></div><a class="modalBenefits_close js_modalBenefitsClose" href="javascript:" aria-label="zavřít"><svg class="svg-icon" aria-hidden="true"><use xlink:href="/build/img/svg/svg-sprite.svg#close"></use></svg></a></div>');

    if(countElements > 1) {
      $('.modalBenefits').prepend('<a class="modalBenefits_arrow modalBenefits_arrow-previous js_modalBenefitsArrow" href="javascript:" data-direction="-1" aria-label="předchozí"><svg class="svg-icon" aria-hidden="true"><use xlink:href="/build/img/svg/svg-sprite.svg#direction"></use></svg></a><a class="modalBenefits_arrow modalBenefits_arrow-next js_modalBenefitsArrow" href="javascript:" data-direction="1" aria-label="následující"><svg class="svg-icon" aria-hidden="true"><use xlink:href="/build/img/svg/svg-sprite.svg#direction"></use></svg></a>');
    }

    $('.benefitsList_link', $block).on('click', function () {
      currentBenefit = $(this).parent().index();
      showBenefitsDetail($(this));
    });
    $('.js_modalBenefitsClose').on('click', function () {
      closeBenefitsDertail();
    });
    $('.js_modalBenefitsArrow.modalBenefits_arrow-previous').on('click', function() {
      changeBenefit('-1');
    });
    $('.js_modalBenefitsArrow.modalBenefits_arrow-next').on('click', function() {
      changeBenefit('+1');
    });
  };

  var showBenefitsDetail = function ($element) {
    $('.modalBenefits_wrapper').html('<div class="modalBenefits_content">' + $element.html() + '</div>');
    $('.modalBenefits .benefitsList_body').removeClass('sr-only');
    $('.modalBenefits').show().css('top', ($(window).scrollTop() + ($(window).height() - $('.modalBenefits').height()) / 2) + 'px');
  };

  var closeBenefitsDertail = function () {
    $('.modalBenefits').hide();
    $('.modalBenefits_wrapper').html('');
  };

  var changeBenefit = function(direction) {
    var newBenefit = currentBenefit;

    if (direction === '+1') {
      newBenefit++;
      newBenefit = (newBenefit == countElements) ? 0 : newBenefit;
    }

    if (direction === '-1') {
      newBenefit--;
      newBenefit = (newBenefit == -1) ? (countElements - 1) : newBenefit;
    }

    $('.modalBenefits_wrapper').html('');
    $('.modalBenefits_wrapper').html('<div class="modalBenefits_content">' + $('.benefitsList_link:eq(' + newBenefit + ')', $block).html() + '</div>');
    $('.modalBenefits .benefitsList_body').removeClass('sr-only');
    $('.modalBenefits').show().css('top', ($(window).scrollTop() + ($(window).height() - $('.modalBenefits').height()) / 2) + 'px');

    currentBenefit = newBenefit;
  };

  init();
};

if ($('.js_benefitsList').length) {
  benefitsListContent();
}

$('#file').change(function () {
  var fileValue = $(this).val();
  $('#fileName').html('Vybraný soubor: <em>' + fileValue.replace(/.*[\/\\]/, '') + '</em>');
});

$('.js_toggleBox').toggleBox();

/********************************************
 * stage list pagination
 *******************************************/
/*$(document).on('STAGE_PAGINATION_ACTIVATE', function () {
	$('.js_pagination-stage').each(function (index, item) {
		var $page = $(item);
		$page.universalPagination({
			listSelector:       '.js_psList',
			itemSelector:       '.js_psItem',
			lang:               projectConfig.lang(),
			nextClass:          'btn',
			nextWrapperClass:   'btn-next-container',
			autoPreloadHistory: false,
			listTopOffset:      15,
			paginationSelector: '.js_pagination-stage'
		});
	});
}).on('ajaxComplete', function () {
	$(document).trigger('STAGE_PAGINATION_ACTIVATE');
});
$(document).trigger('STAGE_PAGINATION_ACTIVATE');*/


// Odscrollování na kotvu nebo jQuery element
window.scrollToAnchor = function (element, customOffset) {
  let targetOffset = parseInt(customOffset) || 0;
  // pokud existuje pevná horní lišta, započte do scrollu i její výšku
  if ($('#sticky-bar').height() > 0) {
    targetOffset += parseInt($(element).offset().top - ($('#sticky-bar').outerHeight()));
  } else {
    targetOffset += parseInt($(element).offset().top);
  }
  $('html,body').animate({scrollTop:targetOffset}, 800);
};
// animace scrollu na hash
$('.js_scroll').on('click', function (e) {
  e.preventDefault();
  scrollToAnchor($(this.hash));
});

// doplneni busId do formulare
$('.js_busHire').busHire();

// Vyhledávání spojení - billeto nezobrozování hashe v URL
$('.header-search-connection, .header-icon-search-link').on('click', function (e) {
  e.preventDefault();
});

$('.radio-select--evaluate').each(function () {
  var $t = $(this);

  $('input', $(this)).on('change', function () {
    var thisIndex = $(this).val();

    $('.radio label', $t).removeClass('active');
    for (var i = 0; i < thisIndex; i++) {
      $('.radio label', $t).eq(i).addClass('active');
    }
  });
});

var linkShowAllNewsParamert = function () {
  if ($('.hp #trafficNewsListForm').length) {
    var category = '';
    var regions = '';
    var i = 1;
    var urlParams = $('.js_allTrafficNews').attr('href').split('?')[0];

    $('input[name*="frm.category"], input[name*="frm.regions"]').on('change', function() {
      regions = '';
      category = 'frm.category=' + $('input[name*="frm.category"]:checked').val();

      $('input[name*="frm.regions"]:checked').each(function() {
        if (i == 1) {
          regions += 'frm.regions=' + this.value;
        } else {
          regions += '&frm.regions=' + this.value;
        }
        i += 1;
      });

      if ($('.js_allTrafficNews').length) {
        if(category.length > 0 || regions.length > 0) {
          urlParams += '?' + category;
          if(category.length > 0 && regions.length > 0) {
            urlParams += '&' + regions;
          } else {
            urlParams += regions;
          }
        }

        $('.js_allTrafficNews').attr('href', urlParams);
      }
    });

  };
};

linkShowAllNewsParamert();

/* YouTube RWD */
$('.wysiwyg iframe[src*="youtube"]').parents('p').addClass('ratio ratio_16_9').wrap('<div class="boxShadow boxShadow-hp">');

// hledani v prodejnich mistech
$('.js_searchPlaces').searchPlaces();

document.addEventListener('DOMContentLoaded', function () {
  const swapButton = document.getElementById('swapStations');

  const startInput = document.querySelector('input[name="frm.startStation"]');
  const endInput = document.querySelector('input[name="frm.endStation"]');

  const startLabelInput = document.querySelector('input[name="frm.startStation:label"]');
  const endLabelInput = document.querySelector('input[name="frm.endStation:label"]');

  if (swapButton && startInput && endInput && startLabelInput && endLabelInput) {
    swapButton.addEventListener('click', function () {
      const tempValue = startInput.value;
      startInput.value = endInput.value;
      endInput.value = tempValue;

      const tempLabelValue = startLabelInput.value;
      startLabelInput.value = endLabelInput.value;
      endLabelInput.value = tempLabelValue;
    });
  }
});

/**
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 */
$.each(q, function (index, f) {
  $(f);
});




// WEBPACK FOOTER //
// ./fe/web-default/src/js/web.js